import { Dropdown, Flex, Input, SearchIcon } from "@fluentui/react-northstar";
import BreadcrumbFolders from "../../components/breadcrumb/BreadcrumbFolders";
import {
    ButtonReset,
    DropdownFilter,
    TableFiles,
} from "../../styles/index.styles";
import { DateRangePickerOneMonth } from "../../../../components/DateRangePicker/DateRangePickerOneMonth";
import useLogicDocumentHrExpenses from "../../hooks/useLogicDocumentHrExpenses";
import BarTools from "../../components/toolbar/BarTools";
import { PaymentRegular } from "@fluentui/react-icons";

const HrDocumentsExpenses = () => {
    const { functions, table, breadcrumb, toolbar, query, filter } =
        useLogicDocumentHrExpenses();

    return (
        <Flex column gap="gap.medium" fill>
            <Flex space="between" align="center">
                {/* breadcrumb */}
                <BreadcrumbFolders
                    breadcrumb={breadcrumb}
                    onClickBreadcrumbItem={functions.handleBreadcrumbItemClick}
                    icon={<PaymentRegular fontSize={24} />}
                />
                <div>
                    <ButtonReset
                        text
                        disabled={filter.disable_reset_button}
                        className={
                            filter.disable_reset_button ? "disabled" : ""
                        }
                        onClick={() => {
                            filter.setClientState([]);
                            filter.setObjectBudgetState([]);
                            filter.setUsersState([]);
                            filter.setResetDatesToNull(new Date().getTime());
                            filter.setRebillableState(0);
                            return filter.setSearchParams();
                        }}
                    >
                        Réinitialiser
                    </ButtonReset>
                </div>
            </Flex>
            {/* filters */}
            <Flex gap="gap.medium">
                <Flex>
                    <DropdownFilter
                        placeholder="Personne ou département"
                        items={filter.user_departments.data}
                        onChange={filter.onChangeUsersDepartments}
                        value={
                            filter.usersState?.length > 0
                                ? filter.usersState
                                : filter.user_departments.data.find((option) =>
                                      filter.defaultSelectedUsers.includes(
                                          option.key
                                      )
                                  ) ?? []
                        }
                        multiple
                        inverted
                        search
                        styles={{
                            "> .ui-dropdown__container": {
                                maxWidth: "250px",
                            },
                        }}
                    />
                </Flex>
                <Flex>
                    <DateRangePickerOneMonth
                        resetDatesToNull={filter.resetDatesToNull}
                        defaultStartDate={filter.searchParams.get("sd")}
                        defaultEndDate={filter.searchParams.get("ed")}
                        onDatesChange={filter.onDatesChange}
                    />
                </Flex>
                <Flex>
                    <DropdownFilter
                        className="category"
                        placeholder="Client"
                        items={filter.clients.data}
                        onChange={filter.onChangeClient}
                        value={
                            filter.clientState?.length > 0
                                ? filter.clientState
                                : filter.clients.data.find((option) => {
                                      return filter.defaultSelectedClients?.includes(
                                          option.key + ""
                                      );
                                  }) ?? []
                        }
                        multiple
                        inverted
                        autoSize
                        search
                    />
                </Flex>
                <Flex>
                    <DropdownFilter
                        className="category"
                        placeholder="Code budgétaire"
                        items={filter.codes_budget.data}
                        onChange={filter.onChangeBudgetCode}
                        value={
                            filter.objectBudgetState?.length > 0
                                ? filter.objectBudgetState
                                : filter.codes_budget.data.find((option) =>
                                      filter.defaultSelectedObjectsBudget.includes(
                                          option.key + ""
                                      )
                                  ) ?? []
                        }
                        multiple
                        inverted
                        search
                    />
                </Flex>
                <Flex>
                    <DropdownFilter
                        className="category"
                        placeholder="Refacturable ou non"
                        items={filter.rebillable_items}
                        onChange={filter.onBillableChange}
                        value={filter.defaultSelectedRebillable}
                        inverted
                        checkable
                    />
                </Flex>
            </Flex>
            {/* tableau */}
            <Flex
                fill
                column
                styles={{
                    position: "relative",
                    minHeight: "400px",
                }}
            >
                <TableFiles
                    variables={{
                        cellContentOverflow: "none",
                    }}
                    header={
                        query.isLoading || query.isFetching
                            ? table.skeleton_header
                            : table.header
                    }
                    rows={
                        query.isLoading || query.isFetching
                            ? table.skeleton
                            : table.rows
                    }
                />
                {/* selections + download + delete items */}
                {toolbar.show && (
                    <BarTools
                        counterSelection={toolbar.counter}
                        disableDelete={toolbar.disableDelete}
                        isDownloading={toolbar.isDownloadingDocumentMultiple}
                        isDeleting={toolbar.isDeletingDocumentMultiple}
                        onClickDeleteMultiple={
                            toolbar.mutateDeleteDocumentMultiple
                        }
                        onClickDownloadMultiple={
                            toolbar.mutateDownloadDocumentMultiple
                        }
                        onReset={() => functions.handleCheckAll(false)}
                    />
                )}
            </Flex>
        </Flex>
    );
};

export default HrDocumentsExpenses;
